import { Toast } from 'models/toasts';
import { ToastActions } from './action-creators';
import { Reducer } from 'redux';
import { actionTypes } from './action-types';

export interface ToastsStore {
  toasts: Toast[];
}

const initialState: ToastsStore = {
  toasts: [],
};

export const toastsReducer: Reducer<ToastsStore, ToastActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    // トースト表示するエラーを追加
    case actionTypes.APPEND_TOASTS:
      const targetToasts: Toast[] = action.payload.map((toast, index) => {
        return {
          toast_id: `${new Date().getTime().toString()}_${index}`,
          content: toast,
        };
      });
      return {
        ...state,
        toasts: [...state.toasts, ...targetToasts],
      };
    // 指定したトーストを削除
    case actionTypes.REMOVE_TOAST:
      return {
        ...state,
        toasts: state.toasts.filter(toast => toast.toast_id !== action.payload),
      };
    // すべてのトーストを削除
    case actionTypes.CLEAR_TOASTS:
      return {
        ...state,
        toasts: [],
      };
    default:
      return state;
  }
};
